import React from 'react';
import { FailedClient } from '../services/api';

/**
 * Names any client the backend could not read for this view. The rest of the
 * page is still accurate for the clients that did load.
 */
export default function FailedClientsNote({ failed }: { failed?: FailedClient[] | null }) {
  if (!failed || failed.length === 0) return null;
  return (
    <div className="panel-note neg" role="status">
      Some clients could not be loaded and are missing below: {failed.map((f) => f?.tenantId).join(', ')}. Try
      refreshing in a minute.
    </div>
  );
}
